import Drawer from "@mui/material/Drawer";
import {
  Avatar,
  Button,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useButtonStyles from "../styles/useButtonStyles";

import { useState, useEffect } from "react";

import axios from "axios";

import { useDispatch } from "react-redux";
import { adminActions } from "../redux/slices/adminSlice";
import { financeActions } from "../redux/slices/financeSlice";
import { loginCognitoActions } from "../redux/slices/loginSlice";
import { loyaltyPointsActions } from "../redux/slices/LoyaltyPointsSlice";
import { memberActions } from "../redux/slices/memberSlice";
import { merchantActions } from "../redux/slices/merchantSlice";
import { receiptsActions } from "../redux/slices/recieptsSlice";
import { roleActions } from "../redux/slices/roleSlice";
import { salesActions } from "../redux/slices/SalesSlice";
import { shopUserActions } from "../redux/slices/shopUserSlice";
import { useAppSelector } from "../redux/hooks";
import { APIConstants } from "../constants/ApiConstants";
import MerchantProfile from "../components/merchant/MerchantProfile";
import theme from "../theme";
import BasicTextField from "../components/forms/formElements/BasicTextField";
import BasicModal from "../components/ui/BasicModal";
import Loader from "../components/ui/Loader";
import { adminProfile } from "../static-models/AdminProfile";

export interface UpdateAdminProps {
  initialFormData: UpdateAdminDataType;
}
export interface UpdateAdminDataType {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  user_role: string;
  email: string;
  status: string;
  designation: String;
  department: string;
}
const paperStyle: React.CSSProperties = {
  padding: "12px",
  borderRadius: 10,
  width: "60%",
  height: "100%",
  justifyContent: "right",
  color: "#1A3263",
};

const UpdateProfile = (props: UpdateAdminProps) => {
  const dispatch = useDispatch();
  const { initialFormData } = props;
  const [selectState, setSelectState] = useState("");
  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<string[]>([]);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [merchant, setMerchant] = useState(false);
  const navigate = useNavigate();
  const [updateAdminFormState, setAdminFormState] =
    useState<UpdateAdminDataType>(initialFormData);
  const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };
  const handleLogout = async () => {
    setLoading(true);
    resetPersistStates();
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };

  const HandleUpdateAdmin = async () => {
    setLoading(true);
    try {
      const response = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.admin,
        updateAdminFormState
      );
      if (response.data.message) {
        setShowModal(true);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const firstName = useAppSelector(
    (state: any) => state.persistReducers.login.firstName
  );
  const lastName = useAppSelector(
    (state: any) => state.persistReducers.login.lastName
  );
  const email = useAppSelector(
    (state: any) => state.persistReducers.login.email
  );
  const department = useAppSelector(
    (state: any) => state.persistReducers.login.department
  );
  const userRole = useAppSelector(
    (state: any) => state.persistReducers.login.userRole
  );
  const groups = localStorage.getItem("groups");
  const userRoleGroup = groups ? JSON.parse(groups) : [];

  useEffect(() => {
    if (userRoleGroup.find((role: any) => role.includes("merchant"))) {
      setMerchant(true);
    }
  }, []);
  const navigateToProfile = async () => {
    navigate("/newProfile");
  };
  return (
    <Grid
      display={"flex"}
      alignItems={"right"}
      justifyContent={"right"}
      height={"100%"}
    >
      <Paper
        style={paperStyle}
        elevation={9}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Grid
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            backgroundColor: theme?.color?.background,
            "&:hover:not(.Mui-disabled)": {
              cursor: "pointer",
            },
          }}
        >
          <Grid
            display={"flex"}
            container
            flexDirection={"column"}
            justifyContent={"left"}
            borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
          >
            <Grid
              item
              display={"flex"}
              justifyContent={"left"}
              alignItems={"left"}
            >
              <Button
                sx={{
                  marginBottom: 3,
                }}
                onClick={navigateToProfile}
              >
                <ArrowBackIosIcon />
              </Button>
              <Typography
                variant="h5"
                sx={{
                  color: theme?.color?.primary,
                  fontFamily: theme.font?.fontFamily.primary,
                  fontWeight: "600",
                  marginBottom: 3,
                }}
              >
                Update Profile
              </Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{
              backgroundColor: theme.color?.background,
              borderRadius: "16px",
            }}
            pt={8}
            pb={8}
          >
            <Grid container gap={4}>
              <Grid item container gap={6}>
                <Grid item md={5.5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      textAlign: "left",
                    }}
                  >
                    First Name *
                  </Typography>
                  <BasicTextField
                    placeholder=""
                    stateKey="firstName"
                    setState={setAdminFormState}
                    defaultValue={firstName}
                  ></BasicTextField>
                </Grid>
                <Grid item md={5.5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      textAlign: "left",
                    }}
                  >
                    Last Name *
                  </Typography>
                  <BasicTextField
                    placeholder=""
                    stateKey="lastName"
                    setState={setAdminFormState}
                    defaultValue={lastName}
                  ></BasicTextField>
                </Grid>
              </Grid>

              <Grid item container gap={6}>
                <Grid item md={5.5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      textAlign: "left",
                    }}
                  >
                    Email
                  </Typography>
                  <BasicTextField
                    readonly
                    placeholder=""
                    stateKey="email"
                    setState={setAdminFormState}
                    defaultValue={email}
                  />
                </Grid>
                <Grid item md={5.5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      textAlign: "left",
                    }}
                  >
                    User Role
                  </Typography>
                  <BasicTextField
                    readonly
                    placeholder=""
                    stateKey="user_role"
                    setState={setAdminFormState}
                    defaultValue={userRole}
                  />
                </Grid>
              </Grid>

              <Grid item container>
                <Grid item md={5.5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      textAlign: "left",
                    }}
                  >
                    Department
                  </Typography>
                  <BasicTextField
                    readonly
                    placeholder=""
                    stateKey="department"
                    setState={setAdminFormState}
                    defaultValue={department}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                container
                mr={6}
                justifyContent={"end"}
                padding={2}
                borderTop={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
              >
                <Button
                  sx={{
                    ...buttonStyles.outlinedSecondary,
                    width: "23%",
                    mr: 2,
                  }}
                  variant="outlined"
                  component={Link}
                  to="/dashboard"
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  sx={{ ...buttonStyles.containedSecondary, width: "23%" }}
                  variant="contained"
                  onClick={HandleUpdateAdmin}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      {uploadError && (
        <BasicModal
          title={"Something went wrong"}
          success={false}
          setState={setUploadError}
        />
      )}
      {loading && <BasicModal content={<Loader />} />}
      {showModal && (
        <BasicModal
          title={"Admin Updated Successfully!"}
          success={true}
          setState={setShowModal}
        />
      )}
    </Grid>
  );
};
export default UpdateProfile;
